module.exports = __webpack_public_path__ + "img/logo-mb-stream.dde1bdf7.svg";